export default "__VITE_ASSET__eac65345__"